import styled, { css } from 'styled-components';
import { getThemeColor, getThemeTypography } from 'utils/styled';
import { createSwitchTransition } from '../utils';
import { SwitchStatusLabelStyleProps } from './types';

const selectedLabelStyle = css<SwitchStatusLabelStyleProps>`
  margin-left: 6px;
  margin-right: auto;
  opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0)};
`;

const unselectedLabelStyle = css<SwitchStatusLabelStyleProps>`
  margin-left: auto;
  margin-right: 6px;
  opacity: ${({ $isSelected }) => ($isSelected ? 0 : 1)};
`;

export const Label = styled.span<SwitchStatusLabelStyleProps>`
  ${createSwitchTransition('opacity')};
  ${getThemeTypography('label')};
  color: ${getThemeColor('white')};
  text-transform: capitalize;

  ${({ $labelType }) =>
    $labelType === 'selected' ? selectedLabelStyle : unselectedLabelStyle};
`;
